// extracted by mini-css-extract-plugin
export default {"container":"Video_container__KybUX","video":"Video_video__dApUM"};